<template>
  <div class="page-register">
    <div class="container">
      <a-tabs @change="onTab">
        <a-tab-pane key="normal" tab="身份证注册（中国大陆）" forceRender>
          <success v-if="success" :successContent="successContent"></success>
          <a-form
            v-else
            layout="horizontal"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :colon="false"
            :form="normalForm"
          >
            <!-- <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item label="用户名">
                  <a-input
                    size="large"
                    placeholder="请输入用户名,长度6-40位"
                    v-decorator="[
                      'loginName',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row> -->
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="中文姓">
                  <a-input
                    size="large"
                    placeholder="请输入姓"
                    v-decorator="[
                      'surname',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    @blur="onLastNameChange"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="中文名">
                  <a-input
                    size="large"
                    placeholder="请输入名"
                    v-decorator="[
                      'name',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    @blur="onFirstNameChange"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item label="拼音姓">
                  <a-input
                    size="large"
                    placeholder="请输入姓拼音"
                    v-decorator="[
                      'engSurname',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    readOnly
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item label="拼音名">
                  <a-input
                    size="large"
                    placeholder="请输入名拼音"
                    v-decorator="[
                      'engName',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    readOnly
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="身份证号">
                  <a-input
                    size="large"
                    placeholder="请输入中国大陆身份证号码"
                    v-decorator="[
                      'certNo',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <mobile-input
                  label="手机号"
                  required
                  :form="normalForm"
                  :validateHandler="handleNormalFieldValidate"
                  @change="onPhoneChange"
                ></mobile-input>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="密码">
                  <a-input
                    size="large"
                    placeholder="请输入密码,8位-15位"
                    type="password"
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="确认密码">
                  <a-input
                    size="large"
                    placeholder="请再次输入密码"
                    type="password"
                    v-decorator="[
                      'confirmPassword',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="手机验证码">
                  <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="8" :areaCode="areaCode" :value="phone" :token="token" @change="onVerificationCodeChange">
                  </user-verification-code>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="验证码">
                  <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
                  </user-slider-captcha>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="other" tab="护照及其他证件注册" forceRender>
          <success v-if="success" :successContent="successContent"></success>
          <a-form
            v-else
            layout="horizontal"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :colon="false"
            :form="otherForm"
          >
            <a-row>
              <!-- <a-col :md="12" :sm="24">
                <a-form-item label="用户名">
                  <a-input
                    size="large"
                    placeholder="请输入用户名,长度6-40位"
                    v-decorator="[
                      'loginName',
                      {
                        rules: [
                          {
                            validator: handleNormalFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col> -->
              <a-col :md="12" :sm="24">
                <a-form-item required label="国籍">
                  <a-select
                    size="large"
                    v-decorator="[
                      'country',
                      {
                        initialValue: 'CN',
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    :options="countries"
                    @change="onCountryChange"
                  >
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row v-if="isCN">
              <a-col :md="12" :sm="24">
                <a-form-item required label="中文姓">
                  <a-input
                    size="large"
                    placeholder="请输入姓"
                    v-decorator="[
                      'surname',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    @blur="onLastNameOtherChange"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="中文名">
                  <a-input
                    size="large"
                    placeholder="请输入名"
                    v-decorator="[
                      'name',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    @blur="onFirstNameOtherChange"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="英文姓">
                  <a-input
                    size="large"
                    placeholder="请输入英文/拼音姓（LAST NAME）"
                    v-decorator="[
                      'engSurname',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    :readOnly="isCN"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="英文名">
                  <a-input
                    size="large"
                    placeholder="请输入英文/拼音名（FIRST NAME）"
                    v-decorator="[
                      'engName',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    :readOnly="isCN"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="证件类型">
                  <a-select
                    size="large"
                    placeholder="请选择证件类型"
                    v-decorator="[
                      'certType',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                    <!-- <a-select-option value="5">身份证</a-select-option> -->
                    <a-select-option value="2">有效护照</a-select-option>
                    <a-select-option value="207">港澳台居民居住证</a-select-option>
                    <a-select-option value="206">台胞证</a-select-option>
                    <a-select-option value="6">军官证</a-select-option>
                    <a-select-option value="3">士兵证</a-select-option>
                    <a-select-option value="14">其他证件</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="证件号码">
                  <a-input
                    size="large"
                    placeholder="请输入所选证件的号码"
                    v-decorator="[
                      'certNo',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                    @blur="onOtherCertNoChange"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="出生日期">
                  <a-date-picker
                    value-format="YYYY-MM-DD"
                    placeholder="请选择出生日期"
                    size="large"
                    :disabled-date="disabledDate"
                    v-decorator="[
                      'birthDate',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-date-picker>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item label="性别">
                  <a-radio-group name="gender" v-decorator="[
                      'gender',
                      {
                        initialValue: 'M',
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ]
                      }
                    ]">
                    <a-radio value="M">
                      男
                    </a-radio>
                    <a-radio value="F">
                      女
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="密码">
                  <a-input
                    size="large"
                    placeholder="请输入密码,8位-15位"
                    type="password"
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="确认密码">
                  <a-input
                    size="large"
                    placeholder="请再次输入密码"
                    type="password"
                    v-decorator="[
                      'confirmPassword',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <mobile-input
                  label="手机号"
                  required
                  :form="otherForm"
                  :validateHandler="handleOtherFieldValidate"
                  @change="onPhoneChange"
                ></mobile-input>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item label="E-MAIL">
                  <a-input
                    size="large"
                    placeholder="请输入联络邮箱（选填）"
                    v-decorator="[
                      'email',
                      {
                        rules: [
                          {
                            validator: handleOtherFieldValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="12" :sm="24">
                <a-form-item required label="手机验证码">
                  <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="8" :areaCode="areaCode" :value="phone" :token="otherToken" @change="onOtherVerificationCodeChange" >
                  </user-verification-code>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item required label="验证码">
                  <user-slider-captcha ref="otherVerify" size="large" @change="onOtherCaptchVerify">
                  </user-slider-captcha>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-tab-pane>
      </a-tabs>
      <!-- 同步注册金鹏会员提示 -->
      <div class="mod-tip" v-if="(ffpTipContent || cmsPageTips) && !success">
        <h4>温馨提示</h4>
        <p v-if="ffpTipContent" v-html="ffpTipContent"></p>
        <p v-if="cmsPageTips" v-html="cmsPageTips.warmPromptContent"></p>
      </div>
      <div class="mod-action" v-if="!success">
        <div class="agreement">
          <AgreementTrack
            :checked="agreement"
            :urls="agreeListUrls"
            description='用户注册'
            pageName='register'
            @change="e => agreement = e"
          >
            我已阅读，理解并同意
            <a v-for="item in agreements" :key="item.title" target="_blank" :href="item.url">{{ item.title }}</a>
          </AgreementTrack>
          <br>
          <a-checkbox style="margin-top: 6px;" v-if="ffpAutoRegisterSettingVisible" v-model="ffpAutoRegister">
            同时注册金鹏俱乐部会员
          </a-checkbox>
          <br>
          <a-checkbox style="margin-top: 6px;" v-model="marketingAutoRegister">
            <span class="imp">我愿意接收金鹏营销信息</span>&nbsp;<span>及时了解更多促销，提高乘机体验</span>
          </a-checkbox>
        </div>
        <a-button type="primary" size="large" :loading="loading" @click="onSubmit">立即注册</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { get } from 'lodash'
import { validate } from '@/utils/validate'
import Success from './components/Success'
import { register, parseToPinyin } from '@/api/login'
import { verify } from '@/api/verify'
import { idCardBirthDay, idCardSex, replaceLinks } from '@/utils/util'
import { getCountry } from '@/api/data'
import eventBus from '../../components/eventBus.js'
import Observer from '@/utils/observer'
import AgreementTrack from '@/components/agreement-track'
import './index'

const cnCities = ['CN', 'HK', 'MO', 'TW']
const verifyItems = ['phone', 'certNo', 'loginName']
const verifyTypeEnum = {
  PhoneRegister: 0,
  EmailRegister: 1,
  LocalIDNumber: 52,
  UserRegister: 5,
  LightUserPhoneRegister: 36
}

export default {
  data () {
    return {
      type: 'normal',
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      normalForm: this.$form.createForm(this, { name: 'normal' }),
      otherForm: this.$form.createForm(this, { name: 'other' }),
      agreement: false,
      phone: '',
      areaCode: '',
      country: 'CN',
      countries: [],
      loading: false,
      success: false,
      agreements: [],
      agreeListUrls: [],
      token: '',
      finalToken: '',
      otherFinalToken: '',
      code: '',
      otherToken: '',
      otherCode: '',
      checkIsSelfMsg: '',
      errCode: '',
      successContent: '',
      // 同步注册金鹏会员配置
      ffpTipContent: '',
      ffpConfirmContent: '',
      ffpAutoRegisterSettingVisible: false,
      ffpAutoRegister: true,
      marketingAutoRegister: true,
      cmsPageTips: null
    }
  },
  computed: {
    isCN () {
      return cnCities.indexOf(this.country) > -1
    }
  },
  async created () {
    let userAppConfig = {}

    if (window.__MICRO_ROOT__) {
      const data = await window.__MICRO_ROOT__.cms.getPageData()

      if (data) {
        userAppConfig = data.config
      }
    }

    this.agreements = userAppConfig.agreements
    this.agreeListUrls = this.agreements.map((item) => {
      return `${item.title}-${item.url}`
    })
    // 同步注册金鹏会员相关参数
    this.ffpTipContent = userAppConfig.ffpTipContent || ''
    this.ffpConfirmContent = userAppConfig.ffpConfirmContent || ''

    if (userAppConfig.ffpAutoRegisterSettingVisible === true) {
      this.ffpAutoRegisterSettingVisible = true
    }

    if (userAppConfig.ffpAutoRegister === false) {
      this.ffpAutoRegister = false
    }

    this.successContent = userAppConfig.successHtml || '注册成功，现在完成实名认证，即可享受会员日折上折优惠！'
    this.fetchCountry()
    this.getCmsData()

    eventBus.$on('get-token', (value) => {
      this.onGetFinalToken(value)
    })
  },
  methods: {
    async getCmsData () {
      try {
        const cmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) || {}
        const cmsPageTips = get(cmsData, 'tips') ?? null
        this.cmsPageTips = replaceLinks(cmsPageTips, window.location.domain)
      } catch (err) {
        console.log('err >>>> ', err)
      }
    },
    onTab (type) {
      this.type = type
      this.errCode = ''
    },
    // 身份证注册表单校验
    handleNormalFieldValidate (rule, value, callback) {
      const formData = this.normalForm.getFieldsValue()
      validate('register-normal', formData, rule.fullField).then(({ valid, error }) => {
        const idx = verifyItems.indexOf(rule.fullField)

        if (!error && idx > -1) {
          return this.onVerify(value, idx, rule.fullField, 'normalform', formData, callback)
        }

        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    // 护照及其他证件注册表单校验
    handleOtherFieldValidate (rule, value, callback) {
      const formData = this.otherForm.getFieldsValue()
      validate('register-other', formData, rule.fullField).then(({ valid, error }) => {
        const idx = verifyItems.indexOf(rule.fullField)

        if (!error && idx > -1) {
          return this.onVerify(value, idx, rule.fullField, 'otherForm', formData, callback)
        }

        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit () {
      this.type === 'normal' ? this.onNormalSubmit() : this.onOtherSubmit()
    },
    // 身份证注册
    onNormalSubmit () {
      // 获取注册所用token
      // this.finalToken = JSON.stringify(window.localStorage.getItem('register-token'))
      // window.localStorage.removeItem('register-token')

      this.normalForm.validateFields((errors, values) => {
        if (!errors) {
          const { token, finalToken, code, agreement, checkIsSelfMsg, ffpAutoRegisterSettingVisible, ffpAutoRegister, ffpConfirmContent, marketingAutoRegister } = this
          if (!code) {
            this.$error({
              content: '请输入手机动态码！',
              centered: true
            })
            return
          }
          if (!token) {
            this.$error({
              content: '请拖动滑块完成验证！',
              centered: true
            })
            return
          }
          if (!finalToken) {
            this.$error({
              content: '请点击获取动态码！',
              centered: true
            })
            return
          }

          if (!agreement) {
            this.$error({
              content: '需要同意用户注册协议及隐私条款',
              centered: true
            })
            return
          }

          const params = {
            smsCode: code,
            token: finalToken,
            registerFFP: Number(ffpAutoRegister),
            userInfo: {
              loginName: values.loginName,
              password: values.password,
              surname: values.surname,
              name: values.name,
              engSurname: values.engSurname,
              engName: values.engName,
              // fullName: values.surname + values.name,
              certType: 5,
              certNo: values.certNo,
              areaCode: values.areaCode,
              phone: values.phone,
              country: 'CN',
              push: marketingAutoRegister ? '1' : '0'
            }
          }

          const observer = new Observer()

          if (ffpAutoRegisterSettingVisible && ffpAutoRegister) {
            observer.add(() => {
              return new Promise((resolve, reject) => {
                this.$confirm({
                  title: '温馨提示',
                  content: ffpConfirmContent,
                  onOk: () => {
                    resolve()
                  },
                  onCancel: () => {
                    reject(new Error('cancel'))
                  },
                  okText: '继续注册',
                  cancelText: '取消注册'
                })
              })
            })
          }

          if (checkIsSelfMsg) {
            observer.add(() => {
              return new Promise((resolve, reject) => {
                this.$confirm({
                  title: '温馨提示',
                  content: checkIsSelfMsg,
                  onOk: () => {
                    reject(new Error('cancel'))
                  },
                  onCancel: () => {
                    resolve()
                  },
                  okText: '去登录',
                  cancelText: '继续注册'
                })
              })
            })
          }

          observer.complete = () => {
            this.register(params)
          }
          observer.start()
        }
      })
    },
    // 护照及其他证件注册
    onOtherSubmit () {
      this.otherForm.validateFields((errors, values) => {
        if (!errors) {
          const { otherToken, otherFinalToken, otherCode, isCN, agreement, checkIsSelfMsg, ffpAutoRegisterSettingVisible, ffpAutoRegister, ffpConfirmContent, marketingAutoRegister } = this

          if (!otherCode) {
            this.$error({
              content: '请输入手机动态码！',
              centered: true
            })
            return
          }
          if (!otherToken) {
            this.$error({
              content: '请拖动滑块完成验证！',
              centered: true
            })
            return
          }
          if (!otherFinalToken) {
            this.$error({
              content: '请点击获取动态码！',
              centered: true
            })
            return
          }

          if (!agreement) {
            this.$error({
              content: '需要同意用户注册协议及隐私条款',
              centered: true
            })
            return
          }

          const params = {
            password: values.password,
            engSurname: values.engSurname,
            engName: values.engName,
            certType: values.certType - 0,
            certNo: values.certNo,
            birthDate: values.birthDate,
            gender: values.gender === 'M' ? 1 : 0,
            phone: values.phone,
            areaCode: values.areaCode,
            email: values.email || '',
            country: values.country,
            push: marketingAutoRegister ? '1' : '0'
          }

          if (isCN) {
            params.surname = values.surname
            params.name = values.name
          }

          const observer = new Observer()

          if (ffpAutoRegisterSettingVisible && ffpAutoRegister) {
            observer.add(() => {
              return new Promise((resolve, reject) => {
                this.$confirm({
                  title: '温馨提示',
                  content: ffpConfirmContent,
                  onOk: () => {
                    resolve()
                  },
                  onCancel: () => {
                    reject(new Error('cancel'))
                  },
                  okText: '继续注册',
                  cancelText: '取消注册'
                })
              })
            })
          }

          if (checkIsSelfMsg) {
            observer.add(() => {
              return new Promise((resolve, reject) => {
                this.$confirm({
                  title: '温馨提示',
                  content: checkIsSelfMsg,
                  onOk: () => {
                    reject(new Error('cancel'))
                  },
                  onCancel: () => {
                    resolve()
                  },
                  okText: '去登录',
                  cancelText: '继续注册'
                })
              })
            })
          }

          observer.complete = () => {
            this.register({
              smsCode: otherCode,
              token: otherFinalToken,
              registerFFP: Number(ffpAutoRegister),
              userInfo: params
            })
          }
          observer.start()
        }
      })
    },
    // 注册接口
    async register (params) {
      this.loading = true

      try {
        const { user: data } = await register(params)

        this.$ls.set('USER_CENTER_INFO', data)
        window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, {
          ...data,
          token: this.$ls.get('USER_CENTER_TOKEN'),
          __next__: true
        })

        this.success = true
      } catch (err) {
        if (err.code === 221100001) {
          const { user: data } = err.data

          this.$ls.set('USER_CENTER_INFO', data)
          window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, {
            ...data,
            token: this.$ls.get('USER_CENTER_TOKEN'),
            __next__: true
          })

          this.successContent = err.message
          this.success = true
          return
        }

        this.loading = false
        this.$error({
          content: err.message,
          centered: true
        })
        this.$refs.verify.refresh()
        this.$refs.otherVerify.refresh()
        if (err.code.toString().includes(1000)) {
          this.errCode = err.code
        }
      }
    },
    onPhoneChange ({ areaCode, phone }) {
      this.areaCode = areaCode
      this.phone = phone
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onOtherCaptchVerify (value) {
      this.otherToken = value
      if (this.errCode.toString().includes(1000)) {
        this.otherFinalToken = value
      }
    },
    onOtherVerificationCodeChange (value) {
      this.otherCode = value
    },
    onGetFinalToken (value) {
      if (this.type === 'normal') {
        this.finalToken = value
      } else if (this.type === 'other') {
        this.otherFinalToken = value
      }
      this.errCode = ''
    },
    onLastNameChange (e) {
      this.normalForm.validateFields(['surname'], (errors, values) => {
        if (!errors) {
          this.toPinyin(e.target.value, 'engSurname', 'normalForm')
        }
      })
    },
    onFirstNameChange (e) {
      this.normalForm.validateFields(['name'], (errors, values) => {
        if (!errors) {
          this.toPinyin(e.target.value, 'engName', 'normalForm')
        }
      })
    },
    onLastNameOtherChange (e) {
      this.otherForm.validateFields(['surname'], (errors, values) => {
        if (!errors) {
          if (this.isCN) {
            this.toPinyin(e.target.value, 'engSurname', 'otherForm')
          }
        }
      })
    },
    onFirstNameOtherChange (e) {
      this.otherForm.validateFields(['name'], (errors, values) => {
        if (!errors) {
          if (this.isCN) {
            this.toPinyin(e.target.value, 'engName', 'otherForm')
          }
        }
      })
    },
    onCountryChange (value) {
      this.country = value
    },
    async toPinyin (value, type, form) {
      try {
        const data = await parseToPinyin({
          value
        })

        this[form].setFieldsValue({ [type]: data })
      } catch (err) {
        this.$message.error({
          content: err.message,
          centered: true
        })
      }
    },
    async onVerify (value, type = 0, name = 'phone', formName, formData, cb) {
      try {
        switch (name) {
          case 'certNo':
            type = verifyTypeEnum.LocalIDNumber
            break
          case 'phone':
            type = verifyTypeEnum.LightUserPhoneRegister
            break
          case 'loginName':
            type = verifyTypeEnum.UserRegister
            break
          default:
            type = verifyTypeEnum.PhoneRegister
            break
        }

        await verify({
          type,
          value,
          ...(name === 'phone' ? { areaCode: formData.areaCode } : {})
        })
        this.checkIsSelfMsg = ''

        cb()
      } catch (err) {
        if (err.code === 100010065) {
          this.checkIsSelfMsg = err.message
          cb()
        } else {
          this.checkIsSelfMsg = ''
          cb(err.message)
        }
      }
    },
    onOtherCertNoChange () {
      this.otherForm.validateFields(['certNo'], (errors) => {
        if (!errors) {
          const values = this.otherForm.getFieldsValue()

          if (values.certType === '5') {
            this.otherForm.setFieldsValue({
              birthDate: idCardBirthDay(values.certNo),
              gender: idCardSex(values.certNo) !== 0 ? 'M' : 'F'
            })
          }
        }
      })
    },
    disabledDate (current) {
      // Can not select days after today and today
      return current && current > moment().endOf('day')
    },
    async fetchCountry () {
      try {
        this.countries = await getCountry()
      } catch (err) {
        this.$message.error({
          content: err.message,
          centered: true
        })
      }
    }
  },
  components: {
    Success,
    AgreementTrack
  }
}
</script>
